import { Search } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

// Bold "ISO · In Search Of" band laid across the bottom of an ad image
export const IsoBadge = ({ size = "md", testid }) => {
  const { lang } = useLanguage();
  const big = size === "lg";
  return (
    <div data-testid={testid} className={`absolute inset-x-0 bottom-0 z-10 flex items-center justify-center gap-2 bg-[#FFC233] text-[#12234A] shadow-[0_-4px_14px_rgba(18,35,74,0.18)] ${big ? "py-2.5" : "py-1.5"}`}>
      <Search size={big ? 20 : 15} strokeWidth={3} />
      <span className={`font-display font-black tracking-[0.18em] ${big ? "text-xl" : "text-sm"}`}>ISO</span>
      <span className={`font-semibold uppercase tracking-wider opacity-80 ${big ? "text-sm" : "text-[11px]"}`}>· {lang === "fr" ? "Recherché" : "In Search Of"}</span>
    </div>
  );
};

export const IsoPlaceholder = ({ big }) => {
  const { lang } = useLanguage();
  return (
    <div className="w-full h-full flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-[#FFF6DD] to-[#FFE7A3] text-[#12234A]" data-testid="iso-placeholder">
      <span className={`rounded-full bg-white/70 flex items-center justify-center ${big ? "h-20 w-20" : "h-14 w-14"}`}><Search size={big ? 36 : 26} className="text-[#F5551E]" strokeWidth={2.5} /></span>
      <span className={`font-display font-extrabold ${big ? "text-2xl" : "text-base"}`}>{lang === "fr" ? "Recherché" : "Wanted"}</span>
    </div>
  );
};
